(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- falling 9s ---------- */
  // One glyph only. Each column has its own size and pace; the head burns hot,
  // the trail cools to red, and every stroke carries the same glow as the titles.
  const GLYPH = '9';
  const PITCH = 24;
  const SIZES = [13, 16, 16, 20, 24];
  const FRAME_MS = 64;
  const HEAD = '#ffe1dc';
  const TRAIL = '#d3121f';
  const GLOW = '#ff1e2c';

  const rain = (canvas) => {
    if (!canvas || canvas.dataset.egmReady) return;
    canvas.dataset.egmReady = '1';
    const ctx = canvas.getContext('2d');
    let width = 0;
    let height = 0;
    let columns = [];
    let timer = null;

    const spawn = (column, late) => {
      column.size = SIZES[Math.floor(Math.random() * SIZES.length)];
      column.every = 1 + Math.floor(Math.random() * 3);
      column.row = -Math.floor(Math.random() * (late ? 46 : 70));
      column.tick = 0;
      // Smaller 9s sit further back: dimmer and softer.
      column.alpha = 0.42 + (column.size - 13) / 11 * 0.58;
    };

    const size = () => {
      const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
      width = canvas.clientWidth;
      height = canvas.clientHeight;
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      columns = Array.from({ length: Math.ceil(width / PITCH) }, (_, index) => {
        const column = { x: index * PITCH + 4 };
        spawn(column, false);
        return column;
      });
      ctx.clearRect(0, 0, width, height);
    };

    const draw = (column, y, colour, blur) => {
      ctx.globalAlpha = column.alpha;
      ctx.shadowColor = GLOW;
      ctx.shadowBlur = blur;
      ctx.fillStyle = colour;
      ctx.fillText(GLYPH, column.x, y);
    };

    const step = () => {
      // Fade what is already there towards transparent, so the page shows through.
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = 1;
      ctx.shadowBlur = 0;
      ctx.fillStyle = 'rgba(0,0,0,0.1)';
      ctx.fillRect(0, 0, width, height);
      ctx.globalCompositeOperation = 'source-over';
      ctx.textBaseline = 'top';
      for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        column.tick += 1;
        if (column.tick % column.every) continue;
        const line = Math.round(column.size * 1.18);
        const y = column.row * line;
        if (y >= -line) {
          ctx.font = column.size + 'px "Share Tech Mono","Space Mono",monospace';
          // The previous head cools into the trail; the new head is drawn hot.
          if (column.row > 0) draw(column, y - line, TRAIL, 7);
          draw(column, y, HEAD, 14);
        }
        column.row += 1;
        if (y > height && Math.random() > 0.94) spawn(column, true);
      }
    };

    const still = () => { for (let i = 0; i < 120; i++) step(); };
    const start = () => { if (!timer && !reduce) timer = window.setInterval(step, FRAME_MS); };
    const stop = () => { window.clearInterval(timer); timer = null; };

    size();
    if (reduce) {
      // A still frame of the rain instead of the animation.
      still();
    } else {
      start();
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    }
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        if (canvas.clientWidth === width && Math.abs(canvas.clientHeight - height) < 120) return;
        size();
        if (reduce) still();
      }, 220);
    });
  };

  /* ---------- text decode ---------- */
  // Same-width characters only, so a decoding line never changes length.
  const NOISE = '0123456789ABCDEF#%&/<>*+=';
  const decode = (el) => {
    const final = el.textContent;
    if (!final.trim()) return;
    const chars = Array.from(final);
    const duration = Math.min(1300, 420 + chars.length * 34);
    const began = performance.now();
    let lastSwap = 0;
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      el.textContent = final;
      el.removeAttribute('aria-label');
    };
    el.setAttribute('aria-label', final);
    // Frames stop in a background tab; the real text must land regardless.
    window.setTimeout(finish, duration + 250);
    const frame = (now) => {
      if (done) return;
      const progress = Math.min(1, (now - began) / duration);
      if (progress >= 1) {
        finish();
        return;
      }
      if (now - lastSwap > 45) {
        lastSwap = now;
        const solved = Math.floor(progress * chars.length);
        el.textContent = chars.map((char, index) => (
          index < solved || char === ' ' ? char : NOISE[Math.floor(Math.random() * NOISE.length)]
        )).join('');
      }
      window.requestAnimationFrame(frame);
    };
    window.requestAnimationFrame(frame);
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-egm-rain]').forEach(rain);
    const targets = Array.from(scope.querySelectorAll('[data-egm-decode]')).filter((el) => !el.dataset.egmDecoded);
    targets.forEach((el) => { el.dataset.egmDecoded = '1'; });
    if (reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        decode(entry.target);
      });
    }, { threshold: 0.6 });
    targets.forEach((el) => io.observe(el));
  };

  const boot = () => init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
